// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2aCxz","rootCenter":"LoadMoreObserver_rootCenter__2OvpU","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__Wu3-y"};